import React from "react";
import PropTypes from "prop-types";
import Scrollbars from "react-custom-scrollbars";
import Styles from "./styles";
// import { WIDGETS } from '../../constants';
import { objToArr } from "../../helpers";
import SortableList from "../SortableList";

const ProjectWidgets = props => {
  const { prefabs: prjPrefabs = {} } = props.project || {};
  const prefabs = objToArr(prjPrefabs).map(item => {
    const prefab = item;
    prefab.icon = `icon-${item.type}`;
    prefab.text = item.name;
    prefab.id = item.key;
    return prefab;
  });

  return (
    <div style={Styles.wrapper}>
      <div style={Styles.heading}>Available prefabs</div>
      <Scrollbars
        autoWidth
        autoWidthMin={0}
        renderTrackHorizontal={({ style, ...rest }) => (
          <div {...rest} style={{ ...style, ...Styles.track }} />
        )}
        renderThumbHorizontal={({ style, ...rest }) => (
          <div {...rest} style={{ ...style, ...Styles.thumb }} />
        )}
      >
        <SortableList
          vertical
          items={prefabs}
          onItemClick={props.onItemClick}
          itemStyle={Styles.project}
        />
      </Scrollbars>
    </div>
  );
};

ProjectWidgets.propTypes = {
  project: PropTypes.object.isRequired,
  onItemClick: PropTypes.func
};

ProjectWidgets.defaultProps = {
  onItemClick: () => {}
};

export default ProjectWidgets;



// WEBPACK FOOTER //
// ./src/components/ProjectWidgets/index.js